/**
 * Footer [New] — newsletter + localization
 * Language: EN · FR → {% form 'localization' %} language_code
 * Currency: Impulse multi-selectors markup (flags + disclosure) → country_code
 * Docs: https://shopify.dev/docs/storefronts/themes/markets/multiple-currencies-languages
 */
(function () {
  'use strict';

  var SECTION_TYPE = 'footer-new';

  function enhanceNewsletter(root) {
    var success = root.querySelector('[data-footer-success]');
    if (!success) return;

    if (success.classList.contains('is-visible')) {
      success.hidden = false;
      return;
    }

    var params = new URLSearchParams(window.location.search);
    if (params.get('customer_posted') === 'true' || params.get('form_type') === 'customer') {
      success.hidden = false;
      success.classList.add('is-visible');
    }
  }

  function submitForm(form) {
    if (!form) return;
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.submit();
    }
  }

  function enhanceLanguageButtons(root) {
    var form = root.querySelector('.vg-footer__locales-form');
    if (!form) return;

    var languageInput = form.querySelector('[data-footer-language-input]');
    if (!languageInput) return;

    form.querySelectorAll('[data-footer-language]').forEach(function (button) {
      button.addEventListener('click', function () {
        var code = button.getAttribute('data-footer-language');
        if (!code) return;
        languageInput.value = code;
        submitForm(form);
      });
    });
  }

  /**
   * Same behavior as Impulse theme.Disclosure for currency:
   * toggle list, set country_code hidden input, submit localization form.
   * Self-contained so it works even if this file loads before theme.js.
   */
  function enhanceCurrencyDisclosure(root) {
    var disclosure = root.querySelector('[data-disclosure-currency]');
    if (!disclosure || disclosure._vgFooterDisclosure) return;
    disclosure._vgFooterDisclosure = true;

    var form = disclosure.closest('form');
    var list = disclosure.querySelector('[data-disclosure-list]');
    var toggle = disclosure.querySelector('[data-disclosure-toggle]');
    var input = disclosure.querySelector('[data-disclosure-input]');
    var options = disclosure.querySelectorAll('[data-disclosure-option]');

    if (!form || !list || !toggle || !input) return;

    function hideList() {
      list.classList.remove('disclosure-list--visible');
      toggle.setAttribute('aria-expanded', 'false');
    }

    function toggleList() {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      list.classList.toggle('disclosure-list--visible');
      toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
    }

    toggle.addEventListener('click', function (event) {
      event.preventDefault();
      toggleList();
    });

    options.forEach(function (option) {
      option.addEventListener('click', function (event) {
        event.preventDefault();
        var value = option.getAttribute('data-value');
        if (!value) return;
        input.value = value;
        hideList();
        submitForm(form);
      });
    });

    disclosure.addEventListener('keyup', function (event) {
      if (event.which === 27 || event.key === 'Escape') {
        hideList();
        toggle.focus();
      }
    });

    document.body.addEventListener('click', function (event) {
      if (!list.classList.contains('disclosure-list--visible')) return;
      if (!disclosure.contains(event.target)) hideList();
    });
  }

  function enhance(root) {
    enhanceNewsletter(root);
    enhanceLanguageButtons(root);
    enhanceCurrencyDisclosure(root);
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="' + SECTION_TYPE + '"]').forEach(enhance);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (!section || !section.querySelector) return;
    var root = section.querySelector('[data-section-type="' + SECTION_TYPE + '"]');
    if (root) enhance(root);
  });

  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    initAll();
  }
})();
